import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import type { ClipperFeatureNagDestination } from '@/lib/onboarding/clipperFeatureNagPreference';

interface ClipperFeatureNagModalProps {
  open: boolean;
  destination: ClipperFeatureNagDestination;
  onContinue: (dismissAll: boolean) => void;
}

export function ClipperFeatureNagModal({
  open,
  destination,
  onContinue,
}: ClipperFeatureNagModalProps) {
  const { t } = useTranslation();
  const [dismissAll, setDismissAll] = useState(false);

  useEffect(() => {
    if (open) setDismissAll(false);
  }, [open]);

  return (
    <Dialog open={open}>
      <DialogContent aria-describedby={undefined} className="max-w-md" hideCloseButton>
        <DialogHeader>
          <DialogTitle>{t('clipperFeatureNag.title')}</DialogTitle>
        </DialogHeader>

        <p className="text-sm leading-relaxed text-muted-foreground">
          {t(destination === 'community-library'
            ? 'clipperFeatureNag.communityLibraryBody'
            : 'clipperFeatureNag.earnBody')}
        </p>

        <div className="flex items-center gap-2.5">
          <Checkbox
            id="clipper-feature-nag-dismiss-all"
            checked={dismissAll}
            onCheckedChange={(checked) => setDismissAll(checked === true)}
          />
          <Label
            htmlFor="clipper-feature-nag-dismiss-all"
            className="cursor-pointer text-sm font-normal text-muted-foreground"
          >
            {t('clipperFeatureNag.dontShowAgain')}
          </Label>
        </div>

        <Button type="button" className="w-full" onClick={() => onContinue(dismissAll)}>
          {t('clipperFeatureNag.continue')}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
